import {Form} from './Form.js';

export class FileForm extends Form {


    /**
     * Send a PUT request to the given URL.
     * .
     * @param {string} url
     */
    put(url) {
        return this.submit('post', url);
    }

    /**
     * Fetch all relevant data for the form.
     */
    data() {
        return this.getFormData(_.clone(this.originalData));
    }

    getFormData(object, form, namespace) {

        let _this = this;
        const formData = form || new FormData();

        for (let propertyName in object) {

            const formKey = namespace ? `${namespace}[${propertyName}]` : propertyName;

            let value = _.get(_this, formKey);

            if (!object.hasOwnProperty(propertyName)) {
                continue;
            }

            if (_.isBoolean(value)) {
                formData.append(formKey, Number(value).toString());

            } else if (_.isDate(value)) {
                formData.append(formKey, value.toISOString());

            } else if (_.isArray(value)) {

                value.forEach((obj, index) => {

                    if (_.isObject(obj)) {
                        _this.getFormData(obj, formData, `${formKey}[${index}]`);
                    } else {
                        formData.append(`${formKey}[${index}]`, obj);
                    }
                });
            } else if (_.isNull(value)) {
                formData.append(formKey, '');

            } else if (_.isObject(value) && !(value instanceof File)) {
                _this.getFormData(value, formData, formKey);

            } else {
                formData.append(formKey, value);
            }
        }

        return formData;
    }

    /**
     * Submit the form.
     *
     * @param {string} requestType
     * @param {string} url
     */
    submit(requestType, url) {
        return new Promise((resolve, reject) => {

            let data = this.data();

            axios[requestType](url, data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
            })
                .then(response => {
                    this.onSuccess(response.data);

                    //this.lastSavedData = data;

                    resolve(response.data);
                })
                .catch(error => {
                    this.onFail(error.response.data.errors);

                    reject(error.response.data);
                });
        });
    }

    /**
     * Validate form data.
     *
     * @param {string} url
     */
    validate(url) {
        return new Promise((resolve, reject) => {
            axios.post(url, this.data(), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
            })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    this.onFail(error.response.data.errors);

                    reject(error.response.data);
                });
        });
    }
}
